var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"cookie"},[_c('div',{staticClass:"cookie-main"},[_c('div',{staticClass:"test"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('400243'))}})]),_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('i',{staticClass:"iconfont icon-guanbi3"})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }